import styled from '@emotion/styled';
import { Stack, StackProps, Typography, TypographyProps } from '@mui/material';
import theme from '@/app/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const CafeName = styled(Typography)<TypographyProps>`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  color: ${theme.palette.gray[900]};
  flex: 1;
  min-width: 0;
`;

export const MetaInfo = styled(Stack)<StackProps>`
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;

export const Info = styled(Typography)<TypographyProps>`
  position: relative;
  font-size: 16px;
  color: ${theme.palette.gray[400]};
`;

export const NameAndScore = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
